import { render } from "./Versus.vue?vue&type=template&id=0a714e8a&scoped=true"
import script from "./Versus.vue?vue&type=script&lang=js"
export * from "./Versus.vue?vue&type=script&lang=js"

import "./Versus.vue?vue&type=style&index=0&id=0a714e8a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a714e8a"]])

export default __exports__